import axios from "../../privateApi";

export const unsubscribeEmail = (userId: string, cioId: string) =>
  axios.patch("users/unsubscribe-emails", {
    uuid: userId,
    cioId,
  });
